import { ApiEndpointConfig } from './api-endpoint-config';

const ENDPOINTS: Record<string, ApiEndpointConfig> = {
  getPCBySessionId: {
    method: 'get',
    url: 'projectcharter/session/{appId}/{sessionId}'
  },
  updatePCField: {
    method: 'put',
    url: 'projectcharter/updatefields'
  },
  shareSession: {
    method: 'post',
    url: 'sessionshare/share'
  }
};

// Programmatically add serviceType to all endpoints
Object.values(ENDPOINTS).forEach((api) => {
  (api as any).serviceType = 'blueprint';
});

export const PROJECT_CHARTER_API_CONSTANTS = ENDPOINTS as typeof ENDPOINTS &
  Record<keyof typeof ENDPOINTS, { serviceType: string }>;
